import getCurrencyConfiguration, { CurrencyConfig } from '../tnew/currency/getCurrencyConfiguration';
import parseMoneyInput from '../tnew/currency/parseMoneyInput';
import dom from '../utils/dom';
import DomEffects from '../utils/DomEffects';
import Field from './OnePageGivingFormField';

class CustomAmountInput {
  notifyChange: () => void;

  $input: HTMLInputElement;

  $container?: HTMLElement;

  currencyConfig?: CurrencyConfig;

  isAmountValid = true;

  constructor($form: HTMLFormElement, notifyChange: () => void) {
    this.notifyChange = notifyChange;

    this.$input = dom.findFrom($form, `[name="${Field.Amount}"]`) as HTMLInputElement;

    if (!this.$input) {
      return;
    }

    this.$container = dom.findFrom($form, '.tn-opg-form__custom-amount-input-container') as HTMLElement;

    const { app } = window.tnew;

    this.currencyConfig = getCurrencyConfiguration(
      app.bcp47LanguageTag,
      app.iso4217CurrencyCode,
    );

    this.$input.addEventListener('input', this.onInputChange);

    this.isAmountValid = !!this.value;
  }

  get rawValue() {
    if (this.$input) {
      return this.$input.value;
    }

    return '';
  }

  get value() {
    if (!this.currencyConfig) {
      return 0;
    }

    const { thousandsSeparator, decimalSeparator } = this.currencyConfig;
    
    const value = parseMoneyInput(this.rawValue, thousandsSeparator, decimalSeparator);
  
    if (!value) {
      return 0;
    }

    return value.amount;
  }

  onInputChange = () => {
    if (!this.currencyConfig) {
      return;
    }

    const { thousandsSeparator, decimalSeparator } = this.currencyConfig;

    const result = parseMoneyInput(this.$input.value, thousandsSeparator, decimalSeparator);

    this.isAmountValid = !result.isEmpty && result.isValid;

    this.notifyChange();
  };

  expand() {
    if (this.$container) {
      DomEffects.expand(this.$container);
    }
  }

  collapse() {
    if (this.$container) {
      DomEffects.collapse(this.$container);
    }
  }
}

export default CustomAmountInput;
